import { Component, OnDestroy, Input, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { get } from 'lodash';
import { IWizardContentComponent } from "../../../wizard.content";


@Component({
  selector: "sites-subnet-html",
  templateUrl: "./sites.subnet.html",
  styleUrls: ['../wizard.sites.style.scss', './sites.subnet.style.scss']
})
export class SitesSubnetHtmlComponent implements IWizardContentComponent, OnInit, OnDestroy, AfterViewInit, IWizardContentComponent {

  @Input() step: any;
  @Input() subStep: any;
  @Input() wizardCtrl: any;
  @Input() previousOutput: any;
  wizardService:any;
  

  constructor() {
  }

  ngOnDestroy() {
  }

  ngAfterViewInit() {
  }

  ngOnInit() {
    this.wizardService = this.wizardCtrl.wizardService;
     // attempt populate inputs, in case user came here by pressing 'back'
     if(this.wizardService.editMode) {
      this.fillFormData();
    }
  }

  fillFormData() {
    this.step.output.subnets = get(this.previousOutput, 'subnets', []);
  }

}
